import * as React from "react";

// Styles
import "./QuestionProgressBar.scss";

interface QuestionProgressBar {
  progress: number;
}

const QuestionProgressBar: React.FC<QuestionProgressBar> = (
  props: QuestionProgressBar
) => {
  const { progress } = props;

  return (
    <div className="progress-bar bg-dw-grey-06 ">
      <div
        className="progress-bar__bar bg-dw-bright-blue absolute left-0 top-0 bottom-0"
        style={{
          width: `${progress}%`,
          transition: "width 0.3s ease-out",
        }}
      />
    </div>
  );
};

export default QuestionProgressBar;
